import styles from "./ArticleDek.module.scss";
import { gql } from "utils/urql";
import { ArticleDekFragment, ArticleLayout } from "types/api";
import cx from "classnames";

const ArticleDek = ({
  dek,
  layout,
}: ArticleDekFragment & { layout: ArticleLayout }) => {
  if (!dek) return null;
  return (
    <p
      className={cx(styles.root, layout === "feature" && styles.feature)}
      dangerouslySetInnerHTML={{ __html: dek }}
    />
  );
};

export default ArticleDek;

ArticleDek.fragment = gql`
  fragment articleSwanDek on Article {
    dek
  }
`;
